import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskAutomationCopyRuleRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-automation-copy-rule',
	path: '/jira/servicedesk/projects/:projectKey/settings/automation/copy/:ruleId',
};
